import { useTranslation } from 'react-i18next';
import { theme } from '../../config/theme';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border bg-surface py-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <span className="font-semibold text-foreground">{theme.brand.name}</span>
        <span>{t('footer.builtFor', { mark: theme.brand.mark })}</span>
        <a className="transition hover:text-foreground" href={`mailto:${theme.brand.supportEmail}`}>
          {theme.brand.supportEmail}
        </a>
      </div>
    </footer>
  );
}
